import React from 'react';
import {
  Box,
  Flex,
  HStack,
  Image,
  useColorModeValue,
} from '@chakra-ui/react';
import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand() {
  const brandShellBg = useColorModeValue(
    'linear-gradient(145deg, rgba(255,255,255,0.78), rgba(111, 66, 193, 0.10))',
    'linear-gradient(145deg, rgba(16, 23, 40, 0.90), rgba(111, 66, 193, 0.14))',
  );
  const brandShellBorder = useColorModeValue(
    'rgba(162,176,210,0.18)',
    'rgba(255,255,255,0.08)',
  );

  return (
    <Flex align="stretch" direction="column" pt="1px">
      <Box px="10px" py="1px" w="100%">
        <HStack spacing="0" align="center" justify="center" w="100%">
          <Box
            p="12px"
            borderRadius="28px"
            bg={brandShellBg}
            border="1px solid"
            borderColor={brandShellBorder}
            boxShadow="0 18px 42px rgba(7, 12, 24, 0.18)"
            backdropFilter="blur(16px)"
            flexShrink="0"
            mx="auto"
          >
            <Box
              overflow="hidden"
              borderRadius="22px"
              bg="white"
              boxShadow="inset 0 1px 0 rgba(255,255,255,0.75)"
            >
              <Image
                src="/logo.png"
                alt="Master Tech Auto"
                w="150px"
                h="82px"
                objectFit="contain"
                display="block"
              />
            </Box>
          </Box>
        </HStack>
      </Box>
      <HSeparator mb="20px" mt="20px" />
    </Flex>
  );
}

export default SidebarBrand;
